'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconSvg = require('../IconSvg');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconEye = function IconEye(props) {
  return _react2.default.createElement(
    _IconSvg.IconSvg,
    props,
    _react2.default.createElement(
      'svg',
      { viewBox: '0 0 24 24' },
      _react2.default.createElement('path', { d: 'M12,4.5C7,4.5,2.7,7.6,1,12c1.7,4.4,6,7.5,11,7.5s9.3-3.1,11-7.5C21.3,7.6,17,4.5,12,4.5z M12,17c-2.8,0-5-2.2-5-5 s2.2-5,5-5s5,2.2,5,5S14.8,17,12,17z M12,9c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3S13.7,9,12,9z' })
    )
  );
};

exports.default = IconEye;


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-icons/dist/IconSvg/icons/IconEye.js
// module id = 719
// module chunks = 0